import { AttributeType } from 'data/types';
import { toFiniteNumber } from 'utils/to-finite-number';
import { applicableWindowsAnswer } from 'utils/window-answer-options';

// A year_built write can make the stored windows answer impossible: a home
// now built 2010 or later is not asked, and a younger home cannot have
// replaced its windows in a decade before it was built. Clearing the answer
// here, where the year is written, keeps the estimate and the saved project
// agreeing without a screen having to watch for it.
export function clearInapplicableWindowsAnswer(
  settings: AttributeType[],
  yearBuilt: unknown
): void {
  const windows = settings.find((setting) => setting.code === 'windows');
  if (!windows || windows.value == null || windows.value === '') {
    return;
  }
  if (
    applicableWindowsAnswer(windows.value, toFiniteNumber(yearBuilt)) === null
  ) {
    windows.value = undefined;
  }
}
